import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { PageHeader } from "../components/ui/kaizen";

const API = process.env.REACT_APP_BACKEND_URL;

// Archives — Gladiateur du Nord : aperçu, exécution P0 (export + flag + masquage, AUCUNE suppression), téléchargement.
export default function ArchivesGdnModule() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/archives/gdn/preview").then((r) => setData(r.data)).catch(() => toast.error("Erreur de chargement"));
  useEffect(() => { load(); }, []);

  const run = async () => {
    const n = (data?.rows || []).reduce((s, r) => s + r.gdn_docs, 0);
    if (!window.confirm(`Archiver « Gladiateur du Nord » ?\n\n• ${n} document(s) exportés en JSON (stockage privé)\n• Flag archived_gdn posé (aucune suppression)\n• Masquage : produits boutique, événement, posts marketing GdN\n• Données financières exportées mais JAMAIS modifiées\n\nContinuer ?`)) return;
    setBusy(true);
    try { const { data: r } = await api.post("/archives/gdn/run?confirm=true"); toast.success(`Archive créée : ${r.flagged} documents flaggés, ${r.masked} masqués`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    setBusy(false);
  };

  if (!data) return <div className="p-6 text-zinc-400">Chargement…</div>;
  const total = data.rows.reduce((s, r) => s + r.gdn_docs, 0);
  return (
    <div className="p-6 max-w-5xl" data-testid="archives-gdn">
      <PageHeader title="🗄️ Archives — Gladiateur du Nord" subtitle="Fermé définitivement · export privé + masquage · aucune suppression" />
      <div className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-4 mb-5 flex items-center justify-between gap-4 flex-wrap">
        <div className="text-sm text-zinc-200">
          <b>{total}</b> document(s) liés à GdN dans {data.rows.filter((r) => r.gdn_docs).length} collections · jamais touchés : {data.protected_never_touched.join(", ")}
        </div>
        <button onClick={run} disabled={busy} data-testid="gdn-archive-run-btn" className="px-4 py-2 rounded-lg bg-amber-600 hover:bg-amber-500 text-black text-sm font-bold disabled:opacity-50">
          {busy ? "Archivage…" : "🗄️ Créer l'archive + masquer (P0)"}
        </button>
      </div>
      <table className="w-full text-sm" data-testid="gdn-preview-table">
        <thead className="text-[10px] uppercase tracking-widest text-zinc-500"><tr><th className="text-left py-1">Collection</th><th>GdN</th><th>Total</th><th>Déjà archivés</th><th>Action</th></tr></thead>
        <tbody>
          {data.rows.filter((r) => r.gdn_docs).map((r) => (
            <tr key={r.collection} className="border-t border-zinc-800" data-testid={`gdn-row-${r.collection}`}>
              <td className="py-1.5 font-mono text-xs text-zinc-200">{r.collection}</td>
              <td className="text-center text-amber-300 font-bold">{r.gdn_docs}</td>
              <td className="text-center text-zinc-500">{r.total}</td>
              <td className="text-center text-emerald-400">{r.already_archived}</td>
              <td className="text-center text-xs">{r.financial ? <span className="text-red-300">💰 financier — export seulement</span> : r.will_mask ? "flag + masquage" : "flag"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3 className="text-[11px] tracking-[0.3em] uppercase text-amber-400 mt-8 mb-2">Exports réalisés</h3>
      {data.runs.length === 0 ? <p className="text-sm text-zinc-500">Aucune archive créée pour l'instant.</p> : (
        <ul className="space-y-1.5">
          {data.runs.map((r) => (
            <li key={r.id} className="flex items-center justify-between gap-3 rounded-lg border border-zinc-800 bg-zinc-900/50 px-3 py-2 text-sm" data-testid={`gdn-run-${r.id}`}>
              <span className="text-zinc-300">{new Date(r.at).toLocaleString("fr-CA")} · {r.by} · {r.flagged} flaggés · {r.masked} masqués · {(r.bytes / 1024).toFixed(0)} Ko</span>
              <a href={`${API}/api/archives/gdn/export/${r.id}?token=${localStorage.getItem("map_token") || ""}`} onClick={async (e) => { e.preventDefault(); const res = await api.get(`/archives/gdn/export/${r.id}`, { responseType: "blob" }); const u = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = u; a.download = r.path.split("/").pop(); a.click(); }}
                className="text-amber-300 hover:text-amber-200 text-xs underline" data-testid={`gdn-download-${r.id}`}>⬇️ JSON</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
